// extracted by mini-css-extract-plugin
export default {"modal":"Popup_modal__H1Daj"};